import React from 'react';
import { Outlet } from 'react-router-dom';
import { usePlan } from '../../hooks/usePlan';
import { LoadingGateRecovery } from './LoadingGateRecovery';

export const SubscriptionGate: React.FC = () => {
  const { loading } = usePlan();

  if (loading) {
    return <LoadingGateRecovery gateName="subscription-gate" spinnerVariant="loader2" />;
  }

  return <Outlet />;
};
